import React, { Component } from 'react';
import './css/Note.css';
import firebase from '../Firebase.js'
import $ from 'jquery'; 

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEdit, faTimes } from '@fortawesome/free-solid-svg-icons'

library.add(faEdit, faTimes)

//import popper from 'popper.js'; 
var moment = require('moment');
//require('bootstrap/dist/js/bootstrap.min.js');
//var popover = require('bootstrap/js/dist/popover.js');

class Note extends Component {

	constructor(props) {
		
		super(props);
		this.state = {
			days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
			daysTargeted: [1, 2, 3, 4, 5],
			editLine: false
		};

		// Load the page in the url or if there is no week number, we load the current week		
		this.props.filter(Object.assign(this.props.filter(), {"week": this.props.props.match.params.week || moment().week()}))		

		// Bind Allow access by "this" into the function
		this.addCtnForDays = this.addCtnForDays.bind(this);
		this.eventAddLine = this.eventAddLine.bind(this);
		this.editView = this.editView.bind(this);
		this.editNote = this.editNote.bind(this);
		this.resetEditView = this.resetEditView.bind(this);
		this.isEditedLine = this.isEditedLine.bind(this);
	}

	componentDidUpdate(){
		/*
		console.log($(".timeCalumn").length);
		
		$(".timeCalumn").popover({"placement": "right", "content": "<button>ok</button>"})
		$(".timeCalumn").popover('show')
		*/
	}

	eventAddLine(e){
		let state = this.state,
			data = this.props.data,
			objOut = {title: null, time: null},
			posDayTargeted = e.target.getAttribute("data-day"),
			nodeTitle = document.querySelector("#inputAddTitle_" + posDayTargeted),
			nodeTime = document.querySelector("#inputAddTime_" + posDayTargeted),
			user = this.props.getUser()

		objOut.title = nodeTitle.value
		objOut.time = nodeTime.value

		if(!nodeTitle.value)
			return false

		// Edit mode
		if(this.state.editLine){
			console.info(this.state.editLine);
			
			let objLine = this.props.data[this.state.editLine.day].task[this.state.editLine.linePos]
			
			this.editNote(Object.assign(objLine, objOut), () => {
				nodeTitle.value = ""
				nodeTime.value = ""
			})
			return;
		}

		// Add mode
		objOut = Object.assign(objOut, {
			userId: user.uid,
			weekNbr: this.props.filter().week,
			dayNbr: posDayTargeted
		});

		let ref = firebase.database().ref("Notes/" + user.uid+"/"+moment().year()),
			newPostKey = ref.push().key

		ref.child(this.props.filter().week+"/"+newPostKey).set(objOut).then(() => {
			console.info('Success, Data saved in Firebase.')
		}).catch(e => {
			console.warn("Error when trying to ave in firebase.")
		});
		
		if(!data[posDayTargeted])
		data[posDayTargeted] = {};

		if(!("task" in data[posDayTargeted]))
		data[posDayTargeted] = {task: []};
		
		data[posDayTargeted].task.push({"title": objOut.title, "time": objOut.time})
		this.setState(state);

		nodeTitle.value = ""
		nodeTime.value = ""
	}

	addCtnForDays(){
		let days = this.state.days;

		return this.state.daysTargeted.map((posDayTargeted, index) => {
			let dataLine = this.addDataToView(posDayTargeted)
			
			return(
				<tr key={days[posDayTargeted]} className="lineAdd">
					<th scope="row" className="align-middle size-number">{index + 1}</th>
					<td className="align-middle size-date font-size-13 border-right">{days[posDayTargeted]}</td>
					<td className="calumn-task" colSpan="2">
						{dataLine.title}
						<div className="input-group ctnPlus invisible" id={"day_"+posDayTargeted}>
							<div className="input-group-prepend">
								<button className="btn btn-outline-secondary bg-light" type="button" data-day={posDayTargeted} onClick={this.eventAddLine}>Add</button>
							</div>
							<input onFocus={(e) => $(e.target).parent().removeClass("invisible")} onBlur={(e) => $(e.target).parent().addClass("invisible")} type="text" className="form-control" placeholder="" aria-label="Example text with button addon" aria-describedby="button-addon1" id={"inputAddTitle_"+posDayTargeted}></input>
							<input type="text" aria-label="Last name" className="form-control size-number" placeholder="1h" defaultValue="1h" id={"inputAddTime_"+posDayTargeted}></input>
						</div>
						<div className="w-25">
							{dataLine.time}
						</div>
					</td>
				</tr>
			)
		});
	}

	isEditedLine(posDayTargeted, index){
		let editLine = this.state.editLine

		if(editLine && editLine.day == posDayTargeted && editLine.linePos == index)
			return true
		return false
	}
	
	addDataToView(posDayTargeted){
		let data = this.props.data,
			editLine = this.state.editLine,
			objOut = {title: [], time: []};

		if(posDayTargeted in data && "task" in data[posDayTargeted] && Array.isArray(data[posDayTargeted].task)){
			// eslint-disable-next-line			
			(data[posDayTargeted].task.map((line, index) => {
				objOut.title.push
					(<div className="d-flex flex-row justify-content-between">
						<div key={index} className={(this.isEditedLine(posDayTargeted, index)? "bg-primary text-white pl-3 pr-3 " : "") + (objOut.title.length > 0? "border-top " : "") + "d-flex flex-row justify-content-between align-items-center w-75"}>
						<p className="m-0">{line.title}</p>
						<span>{
								<button className={(this.isEditedLine(posDayTargeted, index)? "text-white mr-2 " : "") + "btn btn-link p-0 btnFixSize25 text-center"} onClick={() => {
									if(this.isEditedLine(posDayTargeted, index))
										this.resetEditView(posDayTargeted)
									else
										this.editView(posDayTargeted, line, index)
								}
								}><FontAwesomeIcon icon={(this.isEditedLine(posDayTargeted, index)? "times" : "edit")}/></button>
						}</span>
					</div>
					<div key={index} className={(this.isEditedLine(posDayTargeted, index)? "bg-primary text-white pl-3 pr-3 " : "") + (objOut.time.length > 0? "border-top" : "") + " timeCalumn align-self-center text-center w-25"}>
						{line.time}
					</div>
				</div>)
			}));
		}else
			console.info("Miss information in data object")
		return objOut;
	}

	editView(posDayTargeted, objNote, linePos){
		let title = $("#inputAddTitle_"+posDayTargeted),
			time = $("#inputAddTime_"+posDayTargeted)

		// If we select a note to edit after having previously clicked to another one, we need to reset the view
		if(this.state.editLine){
			this.resetEditView(this.state.editLine.day)
		}
		
		title.val(objNote.title)
		time.val(objNote.time)

		this.setState(Object.assign(this.state, {"editLine": {"day": posDayTargeted, "linePos": linePos}}))
	}

	resetEditView(posDayTargeted){
		$("#inputAddTitle_"+posDayTargeted).val("")
		$("#inputAddTime_"+posDayTargeted).val("")

		this.setState(Object.assign(this.state, {"editLine": false}))
	}

	editNote(objNote, callback){
		let filter = this.props.filter(),
			user = this.props.getUser(),
			idNote = objNote.id

		delete objNote.id

		let ref = firebase.database().ref("Notes/" + user.uid+"/"+(filter.year || moment().year())+"/"+(filter.week || moment().week()))

		console.log(objNote);

		let self = this
		ref.child(idNote).set(objNote).then(() => {
			console.info('Success, Data saved in Firebase.')
			self.setState(Object.assign(self.state, {"editLine": false}))
			callback()
		}).catch(e => {
			console.warn("Error when trying to ave in firebase.")
		});
	}

	render() {		
		if(this.props.mustShow){
			//console.log($().popover);
			
			//console.log(popper);
		return (
			<div>
				<div className="container ctnNote shadow p-3 mb-5 bg-white rounded border">
					{this.props.getUser().uid !== this.props.filter().uid && this.props.users()[this.props.filter().uid]? <h3 className="font-weight-bold">{this.props.users()[this.props.filter().uid].email}</h3> : '' }
					<h4>Work Journal: week n°{this.props.filter().week} From: {moment().week(this.props.filter().week).day(0).format('MM-DD-YYYY')} To: {moment().week(this.props.filter().week).day(6).format('MM-DD-YYYY')}</h4>
					<table className="table">
						<thead>
							<tr>
								<th scope="col">#</th>
								<th scope="col">Date</th>
								<th scope="col" className="w-75 text-center">Task</th>
								<th scope="col" className="w-25 text-center">Time</th>
							</tr>
						</thead>
						<tbody>

							{this.addCtnForDays()}
				
						</tbody>
					</table>
				</div>
			</div>
		);

		}else{
			console.warn("Nooottt showww");
			return "";
		}
	}
}

export default Note;



// WEBPACK FOOTER //
// ./src/Pages/Note.js